import './Home.scss';
import useLocale from '../locale/useLocale';
import useTitle from '../helpers/useTitle';
import { AppRoutes } from '../Constants';
import { useNavigate } from 'react-router';
import ChecklistImage from '../assets/pictograms/Checklist.svg';
import ResetImg from '../assets/pictograms/Reset.svg';
import HomeCard from 'components/pages/home/HomeCard';

export const Home = () => {
    const { l } = useLocale();
    const navigate = useNavigate();
    useTitle(l('_home'));

    return (
        <>
            <div className="home-container mt-4">
                <div className="ms-4 mt-4">
                    <h1
                        className="hero-title-text"
                        style={{
                            textAlign: 'left',
                            color: 'black',
                        }}
                    >
                        {l('_homePageWelcomeTo')}
                        &nbsp;
                        {l('_applicationName')}
                    </h1>
                    <p>{l('_landing1')}</p>
                    <p>
                        {l('_pleaseNote')}
                        {l('_submissionDelay')}
                    </p>
                </div>
                <div className="d-flex">
                    <div className="ms-2">
                        <HomeCard
                            imageSrc={ChecklistImage as string}
                            imageAlt="Checklist"
                            heading={l('_submitNewDeclarationHeading')}
                            subheading={l('_forPlannedandUnforeseenSubheading')}
                            buttonText="Start"
                            buttonKind="primary"
                            buttonIcon="icon-arrow-right-outline"
                            backgroundColor="var(--color-background-primary)"
                            onButtonClick={() =>
                                navigate(AppRoutes.CreateDeclaration)
                            }
                        />
                    </div>
                    <HomeCard
                        imageSrc={ResetImg as string}
                        imageAlt="Checklist"
                        heading={l('_viewHistory')}
                        subheading={l('_reviewOrEditSubheading')}
                        buttonText="View"
                        buttonKind="secondary"
                        backgroundColor="#E27588"
                        onButtonClick={() => navigate(AppRoutes.History)}
                    />
                </div>
            </div>
        </>
    );
};

export default Home;
